GP.vent.on('init_js:user:edit_account', function(self) {

	var types = new Array('WYWA_WINK','WYWA_FAVORITED','WYWA_QUICKCHAT','WYWA_RATED','WYWA_MEETME');
    vent.trigger("EditAccount:setup_wywa");

    if (typeof page_selected !== 'undefined' && typeof page_selected_section !== 'undefined') {
        if ( (MoshPit.get_size() == 'mobile') || (MoshPit.get_size() == 'tablet') ) {
            $('#edit_left_col').hide();
            $('#edit_right_col').show();
            $('#edit_right_col #edit_page_content, #edit_right_col #edit_return').show();
        }
        if (page_selected_section == 'wywa_settings') {
            set_wywa_defaults();
        }
    }

    $(window).resize(function() {
        // transition to mobile view
        if ( (MoshPit.get_size() == 'mobile') || (MoshPit.get_size() == 'tablet') ) {
            if ( $('#edit_left_col').is(':visible') && $('#edit_right_col #edit_page_content').is(':visible') ) {
                $('#edit_left_col').hide();
                $('#edit_right_col #edit_page_content, #edit_right_col #edit_return').show();
            }
        // transition to desktop view
        } else if ( (MoshPit.get_size() == 'desktop') || (MoshPit.get_size() == 'desktop-wide') ) {
            $('#edit_right_col #edit_return').hide();
            $('#edit_left_col, #edit_right_col #edit_page_content').show();
        }
        return true;
    });

    self.display_right_col_content = function(data, id) {
        // mobile view
        if ( (MoshPit.get_size() == 'mobile') || (MoshPit.get_size() == 'tablet') ) {
            $('#edit_left_col').hide();
            $('#edit_right_col').show();
            $('#edit_right_col #edit_page_content, #edit_right_col #edit_return').show();
        // desktop view
        } else if ( (MoshPit.get_size() == 'desktop') || (MoshPit.get_size() == 'desktop-wide') ) {
            $('#edit_account_sections li').removeClass();
            $('#edit_account_sections #' + id).addClass('active');
        }

        $('#edit_right_col #edit_page_content').html(data.html);

        // process htmx elements if htmx is loaded
        if (typeof htmx !== 'undefined') {
            htmx.process(document.getElementById('edit_right_col').querySelector('#edit_page_content'));
        }

        return;
    };

    self.goto_blocks_page = function() {
        $.ajax({
            url: '/members/user/edit_account_blocked_users&ajax_request=yes&page=' + $(this).data('page'),
            dataType: 'json',
            success: function(data) {
                self.display_right_col_content(data, 'edit_account_blocked_users');
            }
        });
    };

    self.remove_block = function() {
        $.ajax({
            url: '/members/user/edit_account_blocked_users&ajax_request=yes&page=' + $(this).data('page') + '&unblock_duid=' + $(this).data('duid'),
            dataType: 'json',
            success: function(data) {
                self.display_right_col_content(data, 'edit_account_blocked_users');
            }
        });
    };

    self.edit_menu = function() {
        var id = this.id;
        $.ajax({
            url: '/members/user/' + id,
            dataType: 'json',
            success: function(data) {
                self.display_right_col_content(data, id);
                if (id == 'edit_account_wywa_settings') {
                    set_wywa_defaults();
                    vent.trigger("EditAccount:setup_wywa");
                }
                if (id == 'edit_account_email_settings') {
                    //trigger real-time ajax email setting controls
                    vent.trigger("EditAccount:setup_email_pref");
                }
            }
        });
    };

    $('#edit_account_wrap').on("click", "#more_info_click", function() {
        $("#more_info_div").toggle();
    });
    $('#edit_account_wrap').on("click", "#edit_left_col li", self.edit_menu);
    $('#edit_account_wrap').on('click', '#edit_right_col #edit_page_content div.paging a', self.goto_blocks_page);
    $('#edit_account_wrap').on('click', '#edit_right_col #edit_page_content div.block_user a.unblock', self.remove_block);

    $('#edit_page_content').on("click", ".edit_button", function(event) {
        event.preventDefault();
        var my_column = $(this).closest('div.wyas_column');
        var select = $('select', my_column);
        var custom = $('.custom', my_column);
        if (custom.css('display') == 'none') {
            select.prop('selectedIndex',0);
            select.hide();
            custom.show();
        } else {
            select.show();
            $('input[name^=custom_message]',my_column).val('');
            custom.hide();
        }
    });

    $('#edit_page_content').on("click", "#save_button", function(event){
        event.preventDefault();
        var list = [];
        var data = [];
        var msg_prefs = {};

        var form = $('#settings').serializeArray();
        var x = 0;
        for (var index in form) {
            obj = form[index];
            if (obj.name == 'set'){
                list[x++] = obj.value;
            }
            if (!!(matches = obj.name.match(/([a-z\_]+)\[([a-z\_]+)\]/i))) {
                data_variable = matches[1];
                data_value = matches[2];
                if (data[data_variable] === undefined){
                    data[data_variable] = [];
                }
                data[data_variable][data_value] = obj.value;
            }

            if (obj.name == 'pics_only') {
                msg_prefs.pics_only = obj.value;
            } else if (obj.name == 'local_only') {
                msg_prefs.local_only = obj.value;
            } else if (obj.name == 'age_start') {
                msg_prefs.age_start = obj.value;
            } else if (obj.name == 'age_end') {
                msg_prefs.age_end = obj.value;
            } else if (obj.name == 'auto_reply') {
                msg_prefs.auto_reply = obj.value;
            } else if (obj.name == 'respond_first') {
                msg_prefs.respond_first = obj.value;
            } else if (obj.name == 'msg_approach_pref') {
                msg_prefs.msg_approach_pref = obj.value;
            } else if (obj.name == 'receive_icebreakers') {
                msg_prefs.receive_icebreakers = obj.value;
            }
        }

        post_data = {};
        if ($("#wywa_gender").val() == 'WOMAN') {
            for (index in types) {
                key = types[index];
                if (data.custom_message[key].length && $.trim(data.custom_message[key]) !== '') {
                    post_data[key] = {};
                    post_data[key].setting = 'custom';
                    post_data[key].custom_text = data.custom_message[key];
                } else if ($.inArray(key, list) > -1 && data.wyas_message[key].length && data.wyas_message[key] > 0) {
                    post_data[key] = {};
                    post_data[key].setting = data.wyas_message[key];
                } else if ($.inArray(key, list) > -1 && data.wyas_message[key] == '0') {
                    post_data[key] = {};
                    post_data[key].setting = 'random';
                } else {
                    post_data[key] = {};
                    post_data[key].setting = 'off';
                }
            }
        }

        msg_prefs.verified_only = $('#edit-verified-only').is(':checked') ? 1 : 0;
        msg_prefs.auto_hide = $('#edit-auto-hide').is(':checked') ? 1 : 0;
        msg_prefs.premium_hide = $('#edit-premium-hide').is(':checked') ? 1 : 0;

        $.ajax({
            type: 'POST',
            url: '/members/msg/add_wywa_setting',
            data: {
                settings: post_data,
                msg_prefs: msg_prefs
            },
            dataType: 'json',
            success: function(e) {
                if (e.redirect) {
                    $('#edit-premium-hide').prop("checked", false);
                    GP.vent.trigger('Page:redirect', e.redirect);
                } else {
                    $('div.profile_success').show();
                    $('body,html').animate({
                        scrollTop: 0
                    }, 800);
                }
                // reset msg overlay with new msg settings
                // top.MessagingApp.reset();
            }
        });
    });

    $('#edit_page_content').on("submit", "#change-password-form", function(event) {
        let $form = $(event.target);

        if (!$form.find('input[name="new_password"]').val() || !$form.find('input[name="new_password_confirm"]').val()) {
            alert("Please enter a new password and confirm it.");
            return false;
        }
        var c = confirm("We will now log you out from all active sessions. Please log back in with your new password.");
        return c;
    });

    // handle pagination links on manage notifications page.
    GP.vent.on("edit_account:setup_manage_notifications_binds", function() {
        var _id = 'edit_account_manage_notifications';

        $(".link-notify-pagination").click(function(event) {
            event.preventDefault();
            $.ajax({
                url: '/members/user/' + _id + '/?page=' + $(this).data('page'),
                dataType: 'json',
                success: function(data) {
                    self.display_right_col_content(data, _id);
                }
            });
        });
     });

    function set_wywa_defaults() {
        $.ajax({
            type: 'POST',
            url: '/members/msg/get_wywa_setting',
            success: function(data) {
                for (var index in types) {
                    var x = types[index];
                    if (data.settings[x].setting.length && data.settings[x].setting == 'off') {
                        $('input[name=set][value='+x+']').attr('checked',false);
                    } else {
                        $('input[name=set][value='+x+']').attr('checked',true);
                    }
                    if ($.inArray(data.settings[x], new Array('random','custom'))) {
                        if (data.settings[x].setting == 'custom'){
                            $('select[name="wyas_message['+x+']"]').hide();
                            $('input[name="custom_message['+x+']"]').val(data.settings[x].custom_text);
                            $('select[name="wyas_message['+x+']"]').next('span.custom').show();
                        } else {
                            if ($.inArray(data.settings[x].setting, new Array('random','off')) > -1) {
                                $('select[name="wyas_message['+x+']"]').val(0);
                            } else {
                                $('select[name="wyas_message['+x+']"]').val(data.settings[x].setting);
                            }
                        }
                    }
                }
            }
        });
    }

});
